export { ErrorText } from "./ErrorText"
export type { ErrorTextProps } from "./ErrorText"
